import React from 'react';
import LoadInFunctional from './components/load-in-list-functional';
import './load-in.scss';

const LoadIn = () => {
	return <LoadInFunctional />;
};

export default LoadIn;
